import {EVENTS_NAME, TOTAL_PROFESSIONAL_LEAD_TRIGGERED_DETAIL} from '../../config.js'

const {LEAD_TRIGGERED_CALL_ME_BACK_DETAIL} = EVENTS_NAME

// INPUT:  event='Lead Triggered', lead_type='Call Me Back', seller_type='profesional'
// OUTPUT: ['Total Leads Detalle Profesionales']

export const getCallMeBackDetailEvents = ({event, properties, isProfessionalSeller}) => {
  const matches =
    event === LEAD_TRIGGERED_CALL_ME_BACK_DETAIL.EVENT &&
    properties.lead_type === LEAD_TRIGGERED_CALL_ME_BACK_DETAIL.LEAD_TYPE &&
    isProfessionalSeller

  if (!matches) return []

  return [TOTAL_PROFESSIONAL_LEAD_TRIGGERED_DETAIL]
}
